// extracted by mini-css-extract-plugin
module.exports = {"chatButton":"CustomShopChat_chatButton__V_WJi","unread":"CustomShopChat_unread__9JkIP","chatButtonPosition":"CustomShopChat_chatButtonPosition__7aruw"};